import { render } from "./DocEditor.vue?vue&type=template&id=64bf264a&ts=true"
import script from "./DocEditor.vue?vue&type=script&lang=ts"
export * from "./DocEditor.vue?vue&type=script&lang=ts"

import exportComponent from "K:\\VoionContaract\\voion.contaract.clients\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__